<template>
  <div class="solution-page">
    <PageHeroBanner title="解决方案" title-en="SOLUTION" :image="bannerBg" />

    <div class="container solution-page__sub">
      <p class="breadcrumb">
        <router-link to="/">首页</router-link>
        <span class="breadcrumb__sep">/</span>
        <span class="breadcrumb__here">解决方案</span>
      </p>
    </div>

    <div class="container">
      <div v-if="loading" class="state state--loading">加载中…</div>
      <div v-else-if="!solutions.length" class="state">暂无解决方案数据</div>
      <div v-else class="solution-grid">
        <article v-for="(item, idx) in solutions" :key="item.id" class="solution-tile">
          <router-link :to="detailRoute(item)" class="solution-tile__link">
            <div class="solution-tile__media" :class="{ 'solution-tile__media--ready': imageReady[item.id] }">
              <img
                v-if="item.image"
                class="solution-tile__img"
                :src="item.image"
                :alt="item.title"
                :loading="idx < 8 ? 'eager' : 'lazy'"
                decoding="async"
                :fetchpriority="idx === 0 ? 'high' : idx < 8 ? 'auto' : 'low'"
                @load="onTileImageLoad(item.id)"
                @error="onTileImageLoad(item.id)"
              >
              <div v-else class="solution-tile__ph" aria-hidden="true">{{ shortTitle(item.title) }}</div>
            </div>
            <div class="solution-tile__meta">
              <h2 class="solution-tile__title">{{ item.title }}</h2>
              <p v-if="item.subtitle" class="solution-tile__sub">{{ item.subtitle }}</p>
            </div>
          </router-link>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSolutions } from '../api/solutions'
import PageHeroBanner from '../components/PageHeroBanner.vue'
import { PAGE_BANNER_BG } from '../constants/pageBannerImages'

export default {
  name: 'SolutionCenterView',
  components: { PageHeroBanner },
  data() {
    return {
      bannerBg: PAGE_BANNER_BG.solutions,
      solutions: [],
      loading: false,
      imageReady: {}
    }
  },
  async mounted() {
    this.loading = true
    this.imageReady = {}
    try {
      const list = await fetchSolutions()
      this.solutions = Array.isArray(list) ? list : []
    } finally {
      this.loading = false
    }
  },
  methods: {
    detailRoute(item) {
      return {
        name: 'solution-detail',
        params: { id: String(item.id) }
      }
    },
    shortTitle(t) {
      if (!t || typeof t !== 'string') return '—'
      return t.length <= 6 ? t : t.slice(0, 4)
    },
    onTileImageLoad(id) {
      if (id == null) return
      this.imageReady = { ...this.imageReady, [id]: true }
    }
  }
}
</script>

<style scoped>
.solution-page {
  padding-top: 0;
  min-height: 100vh;
  background: #f1f5f9;
}

.solution-page__sub {
  padding: 20px 20px 8px;
}

.breadcrumb {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 14px;
}

.breadcrumb a { color: #0284c7; }
.breadcrumb a:hover { text-decoration: underline; }
.breadcrumb__sep { margin: 0 8px; color: #cbd5e1; }
.breadcrumb__here { color: #334155; }

.solution-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  padding-bottom: 80px;
}

.solution-tile {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  transition: box-shadow 0.25s, transform 0.25s;
}

.solution-tile:hover {
  box-shadow: 0 16px 40px rgba(12, 74, 110, 0.12);
  transform: translateY(-4px);
}

.solution-tile__link { display: block; color: inherit; }

.solution-tile__media {
  aspect-ratio: 16 / 10;
  background: #f1f5f9;
  overflow: hidden;
  position: relative;
}

.solution-tile__media::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.55) 45%, transparent 90%);
  background-size: 220% 100%;
  animation: solution-tile-shimmer 1.35s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}

.solution-tile__media--ready::after {
  display: none;
}

.solution-tile__img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.solution-tile__media--ready .solution-tile__img {
  opacity: 1;
}

@keyframes solution-tile-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.solution-tile__ph {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%);
  color: rgba(255, 255, 255, 0.9);
  font-size: 26px;
  font-weight: 700;
}

.solution-tile__meta {
  padding: 14px 16px 18px;
}

.solution-tile__title {
  font-size: 18px;
  color: #0f172a;
  font-weight: 600;
  margin: 0 0 6px;
}

.solution-tile__sub {
  font-size: 14px;
  color: #64748b;
  line-height: 1.55;
  margin: 0;
}

.state {
  padding: 48px;
  text-align: center;
  color: #64748b;
  background: #fff;
  border-radius: 10px;
  border: 1px dashed #cbd5e1;
  margin-bottom: 80px;
}

.state--loading { color: #0284c7; }

@media (max-width: 1024px) {
  .solution-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .solution-grid { grid-template-columns: 1fr; }
}
</style>



